// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"707":"nerdmode","962":"home"}[chunkId] + "." + {"707":"8991dd2f","962":"8991dd2f"}[chunkId] + ".chunk.css";
};